import React from "react";
import Section from "../Section";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import { pageTitle } from "../../helpers/PageTitle";
import { Helmet } from "react-helmet";
import SectionHeading from "../SectionHeading";

const row1Data = [
  { iconUrl: "/images/icons/Review1.png" },
  { iconUrl: "/images/icons/Review2.png" },
  { iconUrl: "/images/icons/Review3.png" },
  { iconUrl: "/images/icons/Review4.png" },
  { iconUrl: "/images/icons/Review5.png" },
  { iconUrl: "/images/icons/Review6.png" },
];

const row2Data = [
  { iconUrl: "/images/icons/Review7.png" },
  { iconUrl: "/images/icons/Review8.png" },
  { iconUrl: "/images/icons/Review9.png" },
  { iconUrl: "/images/icons/Review10.png" },
  { iconUrl: "/images/icons/Review11.png" },
];

export default function Review() {
  pageTitle("Patient Reviews");
  return (
    <>
      <Helmet>
        <title>Patient Reviews pluro - Jabalpur Fertility Centre | Success Stories</title>
        <meta name="description" content="Read what our happy patients say about Jabalpur Fertility Centre. Check out reviews and success stories of IVF treatments." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <BannerSectionStyle3
        bgUrl="/images/Review.jpeg"
        title="Patient Reviews"
        subTitle="What Our Patients Say About Pluro Jabalpur Fertility Center"
      />

      <Section
        topMd={ 120 }
        topLg={ 100 }
        topXl={ 80 }
        bottomMd={ 120 }
        bottomLg={ 100 }
        bottomXl={ 80 }
        className="cs_mcp_reviews_section"
      >
        <div className="container">
          <div className="text-center mb-5">
            <SectionHeading
              title="Provides Our Happy Patients"
              titleUp="Reviews"
            />
          </div>
        </div>

        <div className="cs_mcp_reviews_marquee_wrapper">
          {/* Row 1: Right to Left (Normal Speed) */ }
          <div className="cs_mcp_marquee_container mb-4">
            <div className="cs_mcp_marquee_track cs_mcp_marquee_dir_left">
              { [...row1Data, ...row1Data, ...row1Data].map((item, index) => (
                <div className="cs_mcp_review_card" key={ `row1-${index}` }>
                  <div className="cs_mcp_review_card_inner">
                    <img src={ item.iconUrl } alt="Patient Review Google" className="cs_mcp_review_img" />
                  </div>
                </div>
              )) }
            </div>
          </div>

          {/* Row 2: Right to Left (Slightly Faster/Different Offset) */ }
          <div className="cs_mcp_marquee_container">
            <div className="cs_mcp_marquee_track cs_mcp_marquee_dir_left_faster">
              { [...row2Data, ...row2Data, ...row2Data, ...row2Data].map((item, index) => (
                <div className="cs_mcp_review_card" key={ `row2-${index}` }>
                  <div className="cs_mcp_review_card_inner">
                    <img src={ item.iconUrl } alt="Patient Review Google" className="cs_mcp_review_img" />
                  </div>
                </div>
              )) }
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
